import { render, staticRenderFns } from "./jd_search.vue?vue&type=template&id=68d2b15d&scoped=true&"
import script from "./jd_search.vue?vue&type=script&lang=js&"
export * from "./jd_search.vue?vue&type=script&lang=js&"
import style0 from "./jd_search.vue?vue&type=style&index=0&id=68d2b15d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d2b15d",
  null
  
)

export default component.exports